import { useRestoreFocusTarget } from "@fluentui/react-components";
import * as React from "react";
import type { Video } from "./VideoCarousel.web.data";
import { useStyles } from "./VideoCarouselItem.web.styles";

type Props = {
  video: Video;
  id?: string;
  onClick?: () => void;
};

export const CarouselItem: React.FC<Props> = ({ video, id, onClick }) => {
  const restoreFocusTargetAttribute = useRestoreFocusTarget();

  const styles = useStyles();
  return (
    <div
      key={video.id}
      className={styles.li}
      role="listitem"
      aria-label="video carousel list item"
    >
      <div className={styles.root} aria-label={video.description} id={id}>
        <div
          className={styles.supCardControlContentContainer}
          style={{
            transition: "box-shadow .2s ease-in-out",
          }}
        >
          <div
            className={styles.videoContent}
            onClick={onClick}
            onKeyDown={(evt) => {
              if ((evt.key === "Enter" || evt.key === " ") && onClick) {
                evt.preventDefault();
                onClick();
              }
            }}
            role="button"
            tabIndex={0}
            {...restoreFocusTargetAttribute}
          >
            <div className={styles.supCardControlImageContainer}>
              <div className={styles.cardControlImagePlaceholderOverlay}></div>
              <div
                className={styles.supCardControlImage}
                style={{ backgroundImage: `url(${video.thumbnail})` }}
              >
                <img
                  className={styles.cardControlPlayImageFluent}
                  aria-hidden="true"
                  src="https://copilot.cloud-dev.microsoft/images/fluent-play.svg"
                  alt="play button"
                />
                <div className={styles.cardContentWrapper}>
                  <div
                    className={styles.cardContent}
                    style={{
                      background:
                        "linear-gradient(180deg, rgba(255, 255, 255, 0) -3.24%, #FFF 16%)",
                    }}
                  >
                    <div className={styles.supCardControlFooter}>
                      <span
                        className={styles.supCardControlFooterText}
                        title={video.title}
                      >
                        {video.title}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
